import BannerTextColumnBlockPreview from "./BannerTextColumnBlockPreview";

export default BannerTextColumnBlockPreview;